var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useAppSelector } from "conversional-journey";
import { conditionalUtils } from "conversional-utils";
import React from "react";
/**
 * Higher-order-component for processing conditionals
 * Currently just used for filter array-like props
 * --------------
 * The reason we developed an HOC was that we do not want
 * to process conditions on each state change. So it is a lot better
 * if we move out this one-time logic out of the component render logic.
 * */
export function withConditionals(WrappedComponent, _a) {
    var conditionalArray = _a.conditionalArray, conditionalValueInArray = _a.conditionalValueInArray;
    return function (props) {
        /**
         * Just to make sure the whole component is connected to redux because
         * some operand sources may be in Redux and may change over time
         * */
        useAppSelector(function (_a) {
            var updatedAt = _a.common.updatedAt;
            return updatedAt;
        });
        var overrideProps = __assign({}, props);
        if (conditionalArray) {
            var showKey = conditionalArray.showKey, arrayPropName = conditionalArray.arrayPropName;
            overrideProps[arrayPropName] = conditionalUtils.processArrayForConditional(overrideProps[arrayPropName], showKey);
        }
        if (conditionalValueInArray) {
            var valueKey = conditionalValueInArray.valueKey, arrayPropName = conditionalValueInArray.arrayPropName;
            overrideProps[arrayPropName] = conditionalUtils.processArrayForConditionalValue(overrideProps[arrayPropName], valueKey);
        }
        return _jsx(WrappedComponent, __assign({}, overrideProps));
    };
}
